import { render, staticRenderFns } from "./media-icons.vue?vue&type=template&id=ae96cdfa&scoped=true"
import script from "./media-icons.vue?vue&type=script&setup=true&lang=js"
export * from "./media-icons.vue?vue&type=script&setup=true&lang=js"
import style0 from "./media-icons.vue?vue&type=style&index=0&id=ae96cdfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96cdfa",
  null
  
)

export default component.exports